import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const state = {
  potensiKampungs: [],
  potensiKampung: {},
  loading: false,
  getPotensiKampungsError: "",
  getPotensiKampungError: "",
  total: "",
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
